export default __webpack_public_path__ + "static/tech-sheet-tablet-70b244c01fa973ba36f88015de7899a4.png";